module.exports = __webpack_public_path__ + "img/img_size2_hc.d7de0973.png";